export default {
  'roundtrip': {
    'roundtripOptions': 'Options de route circulaire'
  }
}
